var MainModule = angular.module('MainModule', []);

MainModule.controller('MainCtrl', ['$scope', '$timeout', function ($scope, $timeout) {
    $scope.currentCases = 0;
    $scope.lastCase = 1;
    $scope.currentTab = 1;
    $scope.currentPlatform = "";

    $scope.moveCasesPrev = function () {
        if ($scope.currentCases > 0) {
            $scope.currentCases = $scope.currentCases - 1;
        }
    };

    $scope.moveCasesNext = function () {
        if ($scope.currentCases < $scope.lastCase) {
            $scope.currentCases = $scope.currentCases + 1;
        }
    };

    $scope.scrollToForm = function () {
        $('html,body').animate({
                scrollTop: $("#crmWebToEntityForm").offset().top
            },
            'slow');
    };

    $scope.showTooltip = function (type) {
        $scope.currentPlatform = type;
        $(".type").removeClass("out");
    };

    $scope.hideTooltip = function () {
        $(".type").addClass("out");
    };

    $scope.init = function () {
        if ($(window).width() < 500) {
            $scope.lastCase = 11;
        }
        if ($(window).width() < 799 && $(window).width() > 499) {
            $scope.lastCase = 3;
        }
        $timeout(function () {
            $(".hero h1").removeClass("out");
        }, 200);
        $timeout(function () {
            $(".hero h2").removeClass("out");
        }, 300);
        $timeout(function () {
            $(".hero .center").removeClass("out");
        }, 400);
    };

    $scope.flipCard = function (id) {
        $(".feature").removeClass("flipped");
        $("#" + id).addClass("flipped");
    };

    $scope.flipCardBack = function (id) {
        $("#" + id).removeClass("flipped");
    };

    $scope.toggleTabs = function (num) {
        $scope.currentTab = num;
        $timeout(function () {
            $(".tab" + num + " .col1").removeClass("out");
        }, 50);
        $timeout(function () {
            $(".tab" + num + " .col2").removeClass("out");
        }, 100);
        $timeout(function () {
            $(".tab" + num + " .col3").removeClass("out");
        }, 150);
        $timeout(function () {
            $(".tab" + num + " .col4").removeClass("out");
        }, 200);
    };

    $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        if (scroll > 300) {
            $(".header .bg").removeClass("out");
        } else if (scroll < 300) {
            $(".header .bg").addClass("out");
        }
        if (scroll > $(window).height() - 500) {
            $(".what").removeClass("out");
        }
        if (scroll > $(window).height()) {
            $(".platforms").removeClass("out");
        }
        if (scroll > $(window).height() + 2400) {
            $(".tab1 .col1").removeClass("out");
            $timeout(function () {
                $(".tab1 .col2").removeClass("out");
            }, 100);
            $timeout(function () {
                $(".tab1 .col3").removeClass("out");
            }, 200);
            $timeout(function () {
                $(".tab1 .col4").removeClass("out");
            }, 300);
        }

        if (scroll > 100) {
            $(".dist .header .bg").removeClass("out");
        } else if (scroll < 100) {
            $(".dist .header .bg").addClass("out");
        }
    });

}]);
